import React from "react";

function PaginationNumeric({
  currentPage,
  onSelect,
  totalPages,
  isFirstPage,
  isLastPage,
}) {
  function getClassName(page) {
    return page === currentPage
      ? "inline-flex items-center justify-center rounded-l leading-5 px-3.5 py-2 bg-white dark:bg-theme-surface-accent border border-slate-200 dark:border-slate-700 text-indigo-500"
      : "inline-flex items-center justify-center leading-5 px-3.5 py-2 bg-white dark:bg-theme-surface-accent hover:bg-indigo-500 dark:hover:bg-indigo-500 border border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-300 hover:text-white";
  }

  const pagesToShow = [];

  // Always include the first page.
  pagesToShow.push(
    <li key="first">
      <a
        className={getClassName(0)}
        onClick={(e) => {
          e.preventDefault();
          onSelect(0);
        }}
      >
        1
      </a>
    </li>
  );

  // Determine when to show the ellipsis and middle pages based on currentPage
  if (totalPages > 10) {
    if (currentPage < 3) {
      for (let i = 1; i < 5; i++) {
        // Show the first 5 pages
        pagesToShow.push(
          <li key={i}>
            <a
              className={getClassName(i)}
              onClick={(e) => {
                e.preventDefault();
                onSelect(i);
              }}
            >
              {i + 1}
            </a>
          </li>
        );
      }
    } else {
      // Add ellipsis to jump to the middle pages
      pagesToShow.push(
        <li key="ellipsis-1" className={"pl-4 pr-4"}>
          ...
        </li>
      );
      let startPage = Math.max(1, currentPage - 2);
      let endPage = Math.min(currentPage + 3, totalPages - 1); // Adjusted to ensure the range includes currentPage + 2 where possible

      for (let i = startPage; i < endPage; i++) {
        pagesToShow.push(
          <li key={i}>
            <a
              className={getClassName(i)}
              onClick={(e) => {
                e.preventDefault();
                onSelect(i);
              }}
            >
              {i + 1}
            </a>
          </li>
        );
      }
    }

    if (currentPage < totalPages - 4) {
      // Add another ellipsis towards the end if not in the last pages
      pagesToShow.push(
        <li key="ellipsis-2" className={"ml-4 mr-4"}>
          ...
        </li>
      );
    }
  }

  // Show the last page if there are more than 10 pages, adjusting for zero-based currentPage
  if (totalPages > 10) {
    pagesToShow.push(
      <li key={totalPages - 1}>
        <a
          className={getClassName(totalPages - 1)}
          onClick={(e) => {
            e.preventDefault();
            onSelect(totalPages - 1);
          }}
        >
          {totalPages}
        </a>
      </li>
    );
  } else {
    // If totalPages <= 10, simply list all pages without ellipses
    for (let i = 1; i < totalPages; i++) {
      pagesToShow.push(
        <li key={i}>
          <a
            className={getClassName(i)}
            onClick={(e) => {
              e.preventDefault();
              onSelect(i);
            }}
          >
            {i + 1}
          </a>
        </li>
      );
    }
  }

  return (
    <div className="flex">

      <div className="flex justify-center flex-grow pr-4">
        <nav className="flex" role="navigation" aria-label="Navigation">
          <div className="mr-2">
            <a
              onClick={(e) => {
                e.preventDefault();
                if (isFirstPage) return;
                onSelect(currentPage - 1);
              }}
              className={
                isFirstPage
                  ? "inline-flex items-center justify-center rounded leading-5 px-2.5 py-2 bg-white dark:bg-theme-surface-accent border border-slate-200 dark:border-slate-700 text-slate-300 dark:text-slate-600"
                  : "inline-flex items-center justify-center rounded leading-5 px-2.5 py-2 bg-white dark:bg-theme-surface-accent hover:bg-indigo-500 dark:hover:bg-indigo-500 border border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-300 hover:text-white shadow-sm"
              }
            >
              <span className="sr-only">Next</span>
              <wbr />
              <svg className="h-4 w-4 fill-current" viewBox="0 0 16 16">
                <path d="M9.4 13.4l1.4-1.4-4-4 4-4-1.4-1.4L4 8z" />
              </svg>
            </a>
          </div>

          <ul className="inline-flex text-sm font-medium -space-x-px shadow-sm">
            {pagesToShow}
          </ul>
          <div className="ml-2">
            <a
              onClick={(e) => {
                e.preventDefault();
                if (isLastPage) return;
                onSelect(currentPage + 1);
              }}
              className={
                isLastPage
                  ? "inline-flex items-center justify-center rounded leading-5 px-2.5 py-2 bg-white dark:bg-theme-surface-accent border border-slate-200 dark:border-slate-700 text-slate-300 dark:text-slate-600"
                  : "inline-flex items-center justify-center rounded leading-5 px-2.5 py-2 bg-white dark:bg-theme-surface-accent hover:bg-indigo-500 dark:hover:bg-indigo-500 border border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-300 hover:text-white shadow-sm"
              }
            >
              <span className="sr-only">Next</span>
              <wbr />
              <svg className="h-4 w-4 fill-current" viewBox="0 0 16 16">
                <path d="M6.6 13.4L5.2 12l4-4-4-4 1.4-1.4L12 8z" />
              </svg>
            </a>
          </div>
        </nav>
      </div>
    </div>
  );
}

export default PaginationNumeric;
